import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type { OrderView, TenbisStatusActionRequest, TenbisWebsiteModeRequest, TenbisWebsiteModeView } from 'shared-models/browser';

export type { TenbisStatusAction, TenbisStatusActionRequest, TenbisWebsiteModeRequest, TenbisWebsiteModeView } from 'shared-models/browser';

class PosTenbisService {
  // Manager-only: the LAST SENT website mode (Tenbis has no readback), stored on the tenant.
  async getWebsiteMode(tenantId: string, employeeSession: string): Promise<TenbisWebsiteModeView> {
    try {
      const response = await authenticatedInstance.get<TenbisWebsiteModeView>(`/tenbis/tenant/${tenantId}/website-mode`, {
        headers: { 'x-employee-session': employeeSession },
      });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'קריאת סטטוס המסעדה בתן ביס נכשלה'));
    }
  }

  async setWebsiteMode(tenantId: string, employeeSession: string, payload: TenbisWebsiteModeRequest): Promise<TenbisWebsiteModeView> {
    try {
      const response = await authenticatedInstance.post<TenbisWebsiteModeView>(`/tenbis/tenant/${tenantId}/website-mode`, payload, {
        headers: { 'x-employee-session': employeeSession },
      });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'עדכון סטטוס המסעדה בתן ביס נכשל'));
    }
  }

  // POS lifecycle action (accept / out_for_delivery); the backend pushes to Tenbis first.
  async applyStatus(
    tenantId: string,
    employeeSession: string,
    orderId: number,
    payload: TenbisStatusActionRequest,
  ): Promise<OrderView> {
    try {
      const response = await authenticatedInstance.post<OrderView>(
        `/tenbis/tenant/${tenantId}/orders/${orderId}/status`,
        payload,
        { headers: { 'x-employee-session': employeeSession } },
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'עדכון ההזמנה בתן ביס נכשל'));
    }
  }
}

export const posTenbisService = new PosTenbisService();
